import axios from "../api/axios";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

function EditTicket() {
  const { id } = useParams(); // Obtener el ID desde la URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    abonado: "",
    nombre: "",
    direccion: "",
    poblacion: "",
    telefono: "",
    tipoaveria: "",
    descripcion: "",
  });

  useEffect(() => {
    const fetchTicket = async () => {
      try {
        const res = await axios.get(`/api/editTicket/${id}`);
        setFormData(res.data);
      } catch (error) {
        console.error("Error al obtener el ticket:", error);
      }
    };

    fetchTicket();
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(`/api/editTicket/${id}`, formData);

      if (response.status === 200) {
        navigate("../ticket"); // Redirige a la lista de tickets
      } else {
        console.warn("Error al actualizar el ticket:", response.status);
      }
    } catch (error) {
      console.error("Error al actualizar el ticket:", error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-4 gap-4 h-[80vh] min-h-[calc(100vh-6rem)]"
    >
      <div className="col-span-3 bg-secondary-100">
        <h1 className="p-4 px-5 font-bold small-2xl uppercase">Editar Tarea</h1>

        <div className="grid grid-cols-8 min-w-auto px-4 text-xs font-bold uppercase">
          <div className="col-span-1 me-3">
            <input
              id="abonado"
              type="text"
              value={formData.abonado}
              placeholder="Abonado"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>

          <div className="col-span-3 me-3">
            <input
              id="nombre"
              type="text"
              value={formData.nombre_cliente}
              placeholder="Nombre/Empresa"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>

          <div className="col-span-2 me-3">
            <input
              id="telefono"
              type="text"
              value={formData.telefono}
              onChange={handleChange}
              placeholder="Teléfono"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>
          <div className="col-span-2">
            <select
              id="tipoaveria"
              value={formData.tipoaveria}
              onChange={handleChange}
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg uppercase"
            >
              <option value="" disabled>
                Selecciona tipo
              </option>
              <option value="Baja Batería">Baja Batería</option>
              <option value="Avería Zona">Avería Zona</option>
              <option value="Fallo Comunicación">Fallo Comunicación</option>
              <option value="Fallo CCTV">Fallo CCTV</option>
              <option value="Otro">Otro</option>
            </select>
          </div>
        </div>
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-8 me-3">
            <input
              id="direccion"
              type="text"
              value={formData.direccion_cliente}
              placeholder="Direccion"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>
          <div className="col-span-4">
            <input
              id="poblacion"
              type="text"
              value={formData.poblacion_cliente}
              placeholder="Poblacion"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg uppercase"
            />
          </div>
        </div>
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-12">
            <textarea
              id="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
              rows={15}
            />
          </div>
        </div>

        <div className="flex justify-center items-center gap-4">
          <button
            type="submit"
            className="bg-secondary-900 font-bold uppercase py-2 px-6 mt-4 text-sm rounded-lg hover:text-black transition-colors"
          >
            Actualizar
          </button>
          <button
            type="button"
            onClick={() => navigate("../ticket")}
            className="bg-gray-600 font-bold uppercase py-2 px-6 mt-4 text-sm rounded-lg hover:text-black transition-colors"
          >
            Cancelar
          </button>
        </div>
      </div>
    </form>
  );
}

export default EditTicket;
